// Empty stub for modules not needed on web
// This file is intentionally empty or exports nothing
export default {};

